export default __webpack_public_path__ + "static/media/cart.6961024a.png";